import {Logger} from "../../domain/logger.interface";

/**
 * Remote logger implementation for production environments.
 * TODO: Integrate with Sentry for remote logging.
 */
export class RemoteLogger implements Logger {

  debug(message: string, context?: unknown): void {
    // TODO: Send to Sentry
  }

  info(message: string, context?: unknown): void {
    // TODO: Send to Sentry
  }

  warn(message: string, error?: unknown, context?: unknown): void {
    // TODO: Send to Sentry
  }

  error(message: string, error?: unknown, context?: unknown): void {
    // TODO: Send to Sentry
  }
}
